import { render, staticRenderFns } from "./StatsMemberHandicap.vue?vue&type=template&id=f140bc8c&"
import script from "./StatsMemberHandicap.vue?vue&type=script&lang=js&"
export * from "./StatsMemberHandicap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports